
import moment from 'moment';

import {utils } from '../../core';

export default function getAttributeValueAsText(attribute, value) {

    let processedValue = value;

    if (attribute.values) {
        processedValue = utils.processValueWithValues(value, attribute.values);
    } else {
        switch (attribute.type) {
            case 'date':
                let date = moment(value, 'YYYY-MM-DD');
                processedValue = date.isValid()
                    ? date.format('D.M.YYYY')
                    : '-';
                break;
            case 'datetime':
                let datetime = moment(value, 'YYYY-MM-DD HH:mm:ss');
                processedValue = datetime.isValid()
                    ? datetime.format('D.M.YYYY HH:mm')
                    : '-';
                break;
            case 'float':
                processedValue = parseFloat(value).toLocaleString();
                break;
            default:
                // nop;
                break;
        }
    }

    return processedValue;
}
